import api from '../lib/api';

export interface ZendeskConfig {
  subdomain: string;
  email: string;
  token: string;
}

export interface ZendeskStatus {
  connected: boolean;
  lastSync?: string;
  subdomain?: string;
}

export const zendeskService = {
  // Connect to Zendesk
  async connect(organizationId: string, config: ZendeskConfig) {
    const response = await api.post('/integrations/zendesk/connect', {
      organizationId,
      config,
    });
    return response.data;
  },

  // Test connection
  async testConnection(organizationId: string) {
    const response = await api.get(`/integrations/zendesk/${organizationId}/test`);
    return response.data;
  },

  // Get integration status
  async getStatus(organizationId: string): Promise<ZendeskStatus> {
    const response = await api.get(`/integrations/zendesk/${organizationId}/status`);
    return response.data;
  },

  // Sync agents from Zendesk
  async syncAgents(organizationId: string) {
    const response = await api.post(`/integrations/zendesk/${organizationId}/sync-agents`);
    return response.data;
  },

  // Fetch ticket metrics
  async fetchMetrics(organizationId: string, startDate: string, endDate: string) {
    const response = await api.post(`/integrations/zendesk/${organizationId}/fetch-metrics`, {
      startDate,
      endDate,
    });
    return response.data;
  },

  // Sync historical ticket data for forecasting
  async syncHistorical(
    organizationId: string,
    startDate: string,
    endDate: string,
    skillGroupId?: string
  ) {
    const response = await api.post(`/integrations/zendesk/${organizationId}/sync-historical`, {
      startDate,
      endDate,
      skillGroupId,
    });
    return response.data;
  },

  // Disconnect integration
  async disconnect(organizationId: string) {
    const response = await api.post(`/integrations/zendesk/${organizationId}/disconnect`);
    return response.data;
  },
};
